module.exports = __webpack_public_path__ + "static/media/whiteLogo.d5b79434.svg";